import { apiRequest } from "../util/apiUtils";

export const tableList = async (params) => {
  try {
    const res = await apiRequest("get", `table/backend/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const tableDetails = async (payload) => {
  try {
    const res = await apiRequest("get", `/table/backend/detail/${payload?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const tableDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `table/backend/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const tableAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `table/backend/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      }
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};